/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ weeks: NonNullable<unknown>, fromText: NonNullable<unknown>, toText: NonNullable<unknown> }} Progress_Hero_SpanInputs */

const en_us2_progress_hero_span = /** @type {(inputs: Progress_Hero_SpanInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`over 1 week · from ${i?.fromText} to ${i?.toText}`);
	return /** @type {LocalizedString} */ (`over ${i?.weeks} weeks · from ${i?.fromText} to ${i?.toText}`)
	
};

const pt_br2_progress_hero_span = /** @type {(inputs: Progress_Hero_SpanInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`em 1 semana · de ${i?.fromText} para ${i?.toText}`);
	return /** @type {LocalizedString} */ (`em ${i?.weeks} semanas · de ${i?.fromText} para ${i?.toText}`)
	
};

const es_419_progress_hero_span = /** @type {(inputs: Progress_Hero_SpanInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`en 1 semana · de ${i?.fromText} a ${i?.toText}`);
	return /** @type {LocalizedString} */ (`en ${i?.weeks} semanas · de ${i?.fromText} a ${i?.toText}`)
	
};

const pt_pt2_progress_hero_span = /** @type {(inputs: Progress_Hero_SpanInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`em 1 semana · de ${i?.fromText} para ${i?.toText}`);
	return /** @type {LocalizedString} */ (`em ${i?.weeks} semanas · de ${i?.fromText} para ${i?.toText}`)
	
};

const fr_fr2_progress_hero_span = /** @type {(inputs: Progress_Hero_SpanInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`en 1 semaine · de ${i?.fromText} à ${i?.toText}`);
	return /** @type {LocalizedString} */ (`en ${i?.weeks} semaines · de ${i?.fromText} à ${i?.toText}`)
	
};

const de_de2_progress_hero_span = /** @type {(inputs: Progress_Hero_SpanInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`in 1 Woche · von ${i?.fromText} auf ${i?.toText}`);
	return /** @type {LocalizedString} */ (`in ${i?.weeks} Wochen · von ${i?.fromText} auf ${i?.toText}`)
	
};

const it_it2_progress_hero_span = /** @type {(inputs: Progress_Hero_SpanInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`in 1 settimana · da ${i?.fromText} a ${i?.toText}`);
	return /** @type {LocalizedString} */ (`in ${i?.weeks} settimane · da ${i?.fromText} a ${i?.toText}`)
	
};

/**
* | weeks | output |
* | --- | --- |
* | "1" | "over 1 week · from {fromText} to {toText}" |
* | * | "over {weeks} weeks · from {fromText} to {toText}" |
*
* @param {Progress_Hero_SpanInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_hero_span = /** @type {((inputs: Progress_Hero_SpanInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Hero_SpanInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_hero_span(inputs)
	if (locale === "es-419") return es_419_progress_hero_span(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_hero_span(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_hero_span(inputs)
	if (locale === "de-DE") return de_de2_progress_hero_span(inputs)
	if (locale === "it-IT") return it_it2_progress_hero_span(inputs)
	return en_us2_progress_hero_span(inputs)
});
export { progress_hero_span as "progress.hero_span" }